import { IGuidelines } from 'my-poppies-b2b-types';
import { sleep } from 'sleep-lightweight';

import { dummyDataGuidelines } from '@/dummyData/dummyDataGuidelines';

export const mockApiCallForGuidelines = async (): Promise<IGuidelines> => {
  await sleep(250);
  return dummyDataGuidelines;
};
